export default "/kiban/_next/static/images/top_white-7636efd0c2805b59e79fc2a3e60a841b.png";